import { render, staticRenderFns } from "./KassenbuchUebersicht.vue?vue&type=template&id=07b20d17&"
import script from "./KassenbuchUebersicht.vue?vue&type=script&lang=ts&"
export * from "./KassenbuchUebersicht.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports